import React, { useEffect } from 'react';
import PortalLoader from './components/PortalLoader';
import LoadingBar from './components/portals/LoadingBar';
import { useCart } from './hooks/useCart';
import CONSTANTS from './_constants';
import { Toast } from './components/portals/Toast';
import { useDispatch, useSelector } from 'react-redux';

import { Cart } from './util/typings';
import { RootState } from './store/reducers';

import { dispatchToast } from './store/actions/toast';
import CartCountBadge from './components/portals/CartCountBadge';
import RecentlyViewed from './components/portals/RecentlyViewed/index';

import MiniCart from './components/portals/MiniCart/index'
import QuickAdd from './components/portals/QuickAdd/index'
import CountdownTimer from './components/portals/CountdownTimer';
import DeliveryPromise from './components/portals/DeliveryPromise';
import DeliveryPromiseUSA from './components/portals/DeliveryPromiseUSA';


export const App: React.FC = () => {

  const dispatch = useDispatch();
  const cart: Cart = useSelector((state: RootState) => state.cart.current)

  const { initializeCart, setDOMHelpers } = useCart();

  useEffect(() => {
    initializeCart()
  }, []);

  useEffect(() => {
    setDOMHelpers()
  },[cart])

  window['blubolt'].dispatchToast = (type: string, data: any) => dispatch(dispatchToast(type, data));

  return (
    <div>
      <PortalLoader
        dataAttr={CONSTANTS.PORTALS.LOADING}
        Component={LoadingBar}
      />
      <PortalLoader
        dataAttr={CONSTANTS.PORTALS.TOAST}
        Component={Toast}
      />
      <PortalLoader
        dataAttr={CONSTANTS.PORTALS.CART_COUNT_BADGE}
        Component={CartCountBadge}
      />
      <PortalLoader
        dataAttr={CONSTANTS.PORTALS.RECENTLY_VIEWED}
        Component={RecentlyViewed}
      />
      <PortalLoader
        dataAttr={CONSTANTS.PORTALS.MINICART}
        Component={MiniCart}
      />
      <PortalLoader
        dataAttr={CONSTANTS.PORTALS.QUICKADD}
        Component={QuickAdd}
      />
      <PortalLoader
        dataAttr={CONSTANTS.PORTALS.TIMER}
        Component={CountdownTimer}
      />
      <PortalLoader
        dataAttr={CONSTANTS.PORTALS.DELIVERY_PROMISE}
        Component={DeliveryPromise}
      />
      <PortalLoader
        dataAttr={CONSTANTS.PORTALS.DELIVERY_PROMISE_USA}
        Component={DeliveryPromiseUSA}
      />
    </div>
  )
}

export default App;
